export default "__VITE_ASSET__CtZrwbdR__"